// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"18613934","780":"4d7bed64","860":"6238ef16"}[chunkId] + ".chunk.js";
};